import styled, { CreateStyled } from '@emotion/styled'
import { css, keyframes } from '@emotion/core'

export type Theme = {
  base: {
    backgroundColor: string
    viewport: {
      xs: number
      sm: number
      md: number
      lg: number
      xl: number
    }
  }
  fontFamily: {
    primary: string
    headingEn: string
  }
  lineHeight: {
    regular: number
    heading: number
  }
  color: {
    creaith: {
      green: string
      red: string
      yellow: string
      purple: string
    }
    background: {
      primary: string
      gray: string
    }
    button: {
      primary: string
      secondary: string
    }
    text: {
      main: string
      sub: string
      pale: string
      accect: string
    }
  }
}

export const theme: Theme = {
  base: {
    backgroundColor: '#fff',
    viewport: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  fontFamily: {
    primary:
      '"Noto Sans JP", "Helvetica Neue", Arial, "Hiragino Kaku Gothic ProN", "Hiragino Sans", Meiryo, "sans-serif"',
    headingEn: '"Roboto Condensed", "sans-serif"',
  },
  lineHeight: {
    regular: 1.8,
    heading: 1.2,
  },
  color: {
    creaith: {
      green: '#1eb9aa',
      red: '#dc1964',
      yellow: '#fac800',
      purple: '#825096',
    },
    background: {
      primary: '#fff',
      gray: '#f7f7f7',
    },
    button: {
      primary: '#000',
      secondary: '#0d80f6',
    },
    text: {
      main: '#000',
      sub: '#3b454e',
      pale: '#6f6f6Ff',
      accect: '#238edc',
    },
  },
}

export default styled as CreateStyled<Theme>

const mediaQuery = (breakpoint: 'xs' | 'sm' | 'md' | 'lg' | 'xl'): string => {
  return `@media (min-width: ${theme.base.viewport[breakpoint]}px)`
}

export { css, keyframes, mediaQuery }
